import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/lang/index';
import { checkAuth } from '../utils/authUtils';

// Containers
const TheContainer = () => import('@/containers/TheContainer')

//Páginas de cada módulo

//Concursos
const NuevoConcurso = () => import('@/views/concursos/NuevoConcurso')
const EditarConcurso = () => import('@/views/concursos/EditarConcurso')
const ConsultarConcursos = () => import('@/views/concursos/ConsultarConcursos')
const DetallesConcurso = () => import('@/views/concursos/DetallesConcurso')

//Lotes
const DetallesLote = () => import('@/views/lotes/DetallesLote')
const ConsultarLotes = () => import('@/views/lotes/ConsultarLotes')

//Ofertas
const NuevaOferta = () => import('@/views/ofertas/NuevaOferta')
const ConsultarOfertas = () => import('@/views/ofertas/ConsultarOfertas')

//Licitadores
const NuevoLicitador = () => import('@/views/licitadores/NuevoLicitador')
const ConsultarLicitadores = () => import('@/views/licitadores/ConsultarLicitadores')
const DetallesLicitador = () => import('@/views/licitadores/DetallesLicitador')

//Informes
const NuevoInforme = () => import('@/views/informes/NuevoInforme')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

Vue.use(Router)

//TO-DO: Función para comprobar que el usuario ha iniciado sesión, comprobar que el token recibido en el login está almacenado en el local storage, las cookies o la store de vue

const ifAuthenticated = (to, from, next) => {
 // console.log(checkAuth(), to);
  if(checkAuth())
    next()
  else next('/login')
}

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/concursos/lista',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'concursos/crear',
          name: i18n.t('concursos.nuevo'),
          beforeEnter: ifAuthenticated,
          component: NuevoConcurso,
        },
        {
          path: 'concursos/editar*',
          name: i18n.t('concursos.editar'),
          beforeEnter: ifAuthenticated,
          component: EditarConcurso,
        },
        {
          path: 'concursos/lista*',
          name: i18n.t('concursos.consultar'),
          beforeEnter: ifAuthenticated,
          component: ConsultarConcursos,
        },
        {
          path: 'concursos/detalle*',
          name: i18n.t('concursos.detalles'),
          beforeEnter: ifAuthenticated,
          component: DetallesConcurso,
        },
        {
          path: 'lotes/detalle*',
          name: i18n.t('lotes.detalles'),
          beforeEnter: ifAuthenticated,
          component: DetallesLote,
        },
        {
          path: 'lotes/lista',
          name: i18n.t('lotes.consultar'),
          beforeEnter: ifAuthenticated,
          component: ConsultarLotes,
        },
        {
          path: 'ofertas/crear',
          name: i18n.t('ofertas.nuevo'),
          beforeEnter: ifAuthenticated,
          component: NuevaOferta,
        },
        {
          path: 'ofertas/lista',
          name: i18n.t('ofertas.consultar'),
          beforeEnter: ifAuthenticated,
          component: ConsultarOfertas,
        },
        {
          path: 'licitadores/crear',
          name: i18n.t('licitadores.nuevo'),
          beforeEnter: ifAuthenticated,
          component: NuevoLicitador,
        },
        {
          path: 'licitadores/lista',
          name: i18n.t('licitadores.consultar'),
          beforeEnter: ifAuthenticated,
          component: ConsultarLicitadores,
        },
        {
          path: 'licitadores/detalle*',
          name: i18n.t('licitadores.detalles'),
          beforeEnter: ifAuthenticated,
          component: DetallesLicitador,
        },
        {
          path: 'informes/nuevo',
          name: i18n.t('informes.nuevo'),
          beforeEnter: ifAuthenticated,
          component: NuevoInforme,
        },
      ]
    },
    {
      path: '/login',
      
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: '',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

